function setCookie(key, value, expiry = 1) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + '; path=/; expires=' + expires.toUTCString() + '; SameSite=Lax; Secure';
}

function getCookie(key) {
    return document.cookie
        .split('; ')
        .find(row => row.startsWith(`${key}=`))
        ?.split('=')[1];
}

module.exports = {
    setCookie,
    getCookie
}